import { render, staticRenderFns } from "./NovelDeleteConfirm.vue?vue&type=template&id=23679b72&scoped=true"
import script from "./NovelDeleteConfirm.vue?vue&type=script&lang=ts"
export * from "./NovelDeleteConfirm.vue?vue&type=script&lang=ts"
import style0 from "./NovelDeleteConfirm.vue?vue&type=style&index=0&id=23679b72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23679b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23679b72')) {
      api.createRecord('23679b72', component.options)
    } else {
      api.reload('23679b72', component.options)
    }
    module.hot.accept("./NovelDeleteConfirm.vue?vue&type=template&id=23679b72&scoped=true", function () {
      api.rerender('23679b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/novel/NovelDeleteConfirm.vue"
export default component.exports